// extracted by css-extract-rspack-plugin
export default {"cls1":"BulkDownloadPing-cls1_UMB","cls2":"BulkDownloadPing-cls2_lsh BulkDownloadPing-cls1_UMB"};